// Métodos de pago del venue + los dos por defecto, en UNA sola lista para
// todas las pantallas que capturan cómo se movió el dinero (pagos del
// cliente, pago a proveedor, costos, gastos generales, retiros, depósitos).
//
// Antes cada pantalla armaba la suya: solo EventPage mezclaba Efectivo y
// Transferencia; proveedores y costos usaban la colección cruda (vacía si el
// venue nunca abrió Configuración, donde se siembran), y Cuentas y depósitos
// eran texto libre. Resultado: "Transferencia" en un lado, "transferencia" y
// "Transf." en otros, y nada que agrupar después.
//
// Los por defecto llevan id `_default_*` y NO existen en Firestore hasta que
// MetodosPagoManager los siembra; por eso el manager sigue trabajando con la
// colección cruda (`metodosPago` del provider) y el resto con esta lista.

export const DEFAULT_METODOS = [
  { id: "_default_efectivo", nombre: "Efectivo" },
  { id: "_default_transferencia", nombre: "Transferencia" },
];

const norm = (s) => String(s || "").trim().toLowerCase();

export function metodosPagoConDefaults(lista) {
  const propios = (Array.isArray(lista) ? lista : []).filter((m) => m && norm(m.nombre));
  const nombres = new Set(propios.map((m) => norm(m.nombre)));
  const merged = [...propios];
  DEFAULT_METODOS.forEach((d) => {
    if (!nombres.has(norm(d.nombre))) merged.push(d);
  });
  return merged.sort((a, b) =>
    (a.nombre || "").localeCompare(b.nombre || "", "es", { sensitivity: "base" })
  );
}
